import comp from "./CourseBasedGradingWrapper";
export default comp;
